import { Component, Input, OnInit } from "@angular/core";
import { CountryType, CurrencyList, LanguageList } from "./flag.helper";
import { incomingLanguages } from "../../constants";


@Component({
  selector: 'app-flag',
  templateUrl: 'flag.component.html',
  styleUrl: 'flag.component.less',
})

export class FlagComponent implements OnInit{
  @Input() language!: string;
  @Input() currency!: string;
  @Input() country!: CountryType;

  public flag!: string;

  getFlag() {
    if (this.country) {
      this.flag = this.country?.toLowerCase();
    }
    else if (this.language) {
      let tmp =  this.language?.toLocaleLowerCase();
      if (tmp.match('-')) {
        tmp = tmp.split('-')[0];
      }
      const found = incomingLanguages.find(i => i.incoming === tmp || i.lang === tmp)?.incoming;
      console.log(found);
      this.flag =  LanguageList[found || this.language?.toLowerCase()];
      
    } else {
      this.flag = CurrencyList[this.currency?.toLowerCase()];
    }
  }

  ngOnInit(): void {
    this.getFlag();
  }
}